/**
 * 
 */
const groundSellerName = ( sl_ground_seller_total, sl_ground_seller_curr ) => [
    sl_ground_seller_curr.hr_employee.names,
    sl_ground_seller_curr.hr_employee.last_name1,
].join( ' ' )

//
export default [
    {
        text    : 'rut',
        value   : 'rut',
    },
    {
        text    : 'cliente',
        value   : 'alias_name',
    },
    {
        text    : 'vendedor asignado',
        value   : ({ sl_ground_seller }) => sl_ground_seller.reduce( groundSellerName, '-' ),
    },
    {
        text    : 'Morosidad',
        value   : ({ status }) => status && status.label,
    },
    {
        text    : 'Estado',
        align   : 'center',
        value   : ({ blocked_sales }) => blocked_sales ? 'Bloqueado' : '-',
    },
    {
        text    : 'Monto',
        format  : 'currency',
        align   : 'center',
        value   : 'balance',
    },
]
